import ColumnEditor from './ColumnEditor.js';

export default ColumnEditor;
